import { z } from 'zod/v4';
// Location level (court hierarchy)
export const LocationLevelSchema = z.enum([
    'Federal',
    'State',
    'Sheriff',
]);
// Court type classification
export const LocationTypeSchema = z.enum([
    'District Court',
    'Circuit Court',
    'Bankruptcy Court',
    'Superior',
    'County Recorder',
    'Family',
    'Appellate',
    'Archives',
    'Small Claims',
    'Probate & Family',
    'Probate',
    'WCAB',
    'Supreme',
    'Secretary of State',
    'Tribal',
    'State Agency',
    'County',
    'State',
]);
// Service types available at a location (8 CSV flags)
export const ServiceTypeSchema = z.enum([
    'filing',
    'document-retrieval',
    'courtesy-copy',
    'county-recorders',
    'secretary-state',
    'efiling',
    'serve',
    'writ',
]);
// Service flags object
export const ServiceFlagsSchema = z.object({
    filing: z.boolean(),
    documentRetrieval: z.boolean(),
    courtesyCopy: z.boolean(),
    countyRecorders: z.boolean(),
    secretaryState: z.boolean(),
    efiling: z.boolean(),
    serve: z.boolean(),
    writ: z.boolean(),
});
// Location status
export const LocationStatusSchema = z.enum([
    'active',
    'inactive',
]);
// Day schedule with filing deadlines
export const DayScheduleSchema = z.object({
    open: z.string(), // "08:30 AM"
    close: z.string(), // "04:00 PM"
    deadline: z.string(), // "02:00 PM" — physical filing deadline
    efile: z.string(), // "11:50 PM" — e-filing deadline
});
// Operating hours (Mon–Fri)
export const OperatingHoursSchema = z.object({
    monday: DayScheduleSchema.optional(),
    tuesday: DayScheduleSchema.optional(),
    wednesday: DayScheduleSchema.optional(),
    thursday: DayScheduleSchema.optional(),
    friday: DayScheduleSchema.optional(),
});
// Location schema — court locations from DB
export const LocationSchema = z.object({
    id: z.string().uuid(),
    // Legacy fields (backward compat)
    County: z.string(),
    Jurisdiction: z.string(),
    Address: z.string(),
    City: z.string(),
    State: z.string(),
    'Pricing Zone': z.string(),
    'Offer to Affiliates?': z.string(),
    // Enriched fields
    locationName: z.string().nullable(),
    zip: z.string().nullable(),
    level: z.string().nullable(),
    courtType: z.string().nullable(),
    isActive: z.boolean(),
    source: z.string().nullable(),
    serviceFlags: ServiceFlagsSchema,
    operatingHours: OperatingHoursSchema.nullable(),
    locationTimeToDeliver: z.number().nullable(),
    officeTimeToDeliver: z.number().nullable(),
});
export const CreateLocationSchema = z.object({
    county: z.string(),
    jurisdiction: z.string(),
    address: z.string(),
    city: z.string(),
    state: z.string().default('CA'),
    pricingZone: z.string().optional(),
    offerToAffiliates: z.boolean().optional(),
    locationName: z.string().optional(),
    zip: z.string().optional(),
    level: z.string().optional(),
    courtType: z.string().optional(),
    isActive: z.boolean().optional(),
    serviceFlags: ServiceFlagsSchema.partial().optional(),
    operatingHours: OperatingHoursSchema.nullable().optional(),
    locationTimeToDeliver: z.number().nullable().optional(),
    officeTimeToDeliver: z.number().nullable().optional(),
});
export const UpdateLocationSchema = CreateLocationSchema.partial();
// Location preview for hover displays
export const LocationPreviewSchema = z.object({
    id: z.string().uuid(),
    locationName: z.string().nullable(),
    level: z.string().nullable(),
    courtType: z.string().nullable(),
    County: z.string(),
    'Pricing Zone': z.string(),
    isActive: z.boolean(),
    serviceFlags: ServiceFlagsSchema,
});
